import * as _ from 'lodash';
import { DateTime } from 'luxon';
interface Map {
  [key: string]: string | undefined;
}
export function isNumeric(value: any): boolean {
  return isNaN(Number(value)) === false;
}

export function isNullOrEmpty(value: any): boolean {
  return (
    typeof value === 'undefined' ||
    value == null ||
    (typeof value === 'string' && value === '')
  );
}

export const orderBy = <T>(array: T[], key: keyof T): T[] => {
  return array.sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return valueA.localeCompare(valueB);
    }

    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });
};

export function isEmptyObject(obj: any): boolean {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function isJSON(value: string): boolean {
  try {
    const jsonValue = JSON.stringify(value);
    return true;
  } catch (error) {
    return false;
  }
}

export function deepCopy<T>(obj: T): T {
  if (isNullOrEmpty(obj)) {
    return obj;
  }
  return _.cloneDeep(obj);
}

export function convertTimezoneToLocal(date: Date, reverse: boolean): Date {
  if (isNullOrEmpty(date)) {
    return date;
  }
  const reverseValue = reverse ? -1 : 1;
  const dateTimezoneOffset = date.getTimezoneOffset();
  const timezoneOffset = 0 - DateTime.local().offset;
  const localDate = new Date(date.getTime());
  localDate.setMinutes(
    localDate.getMinutes() +
      reverseValue * (timezoneOffset - dateTimezoneOffset)
  );
  return localDate;
}
/**
 * trim object (string) value
 *
 * @export
 * @param {object} inputCols
 * @return {*}  {object}
 */
export function trimObject(object: Map): Map {
  for (const [key, value] of Object.entries(object)) {
    object[key] = typeof value === 'string' ? value?.trim() ?? '' : value;
  }
  return object;
}
/**
 * Get obj value by key
 * @param key
 * @param Object
 * @returns
 */
export function getObjValueByObjKey(key: any, obj: any): any {
  return obj[key] || key;
}
